import { WebAPIEventResult } from '@/globals/webApiTypes/elements/WebAPIEvent';
import { matchesSelectedFiltersByQueryKeys } from '@/sections/filter/matchesSelectedFilters';
import { SelectedFiltersMap } from '@/sections/filter/getSelectedFilters';
import {
	eventFilterQueryKeys,
	EventFilters,
} from './eventFilter/eventsFilterKeys';

const eventResultFieldByQueryKey = {
	subject: 'subjects',
	region: 'regions',
} as const satisfies Record<
	keyof typeof eventFilterQueryKeys,
	keyof WebAPIEventResult
>;

const eventOptionsFieldByQueryKey = {
	subject: 'subjects',
	region: 'regions',
} as const satisfies Record<
	keyof typeof eventFilterQueryKeys,
	keyof EventFilters
>;

const matchesSelectedFiltersConfig = {
	filterQueryKeys: eventFilterQueryKeys,
	resultFieldByQueryKey: eventResultFieldByQueryKey,
	optionsFieldByQueryKey: eventOptionsFieldByQueryKey,
} as const;

const matchesSelectedFilters = (
	result: WebAPIEventResult,
	selectedFilters: SelectedFiltersMap,
	filters: EventFilters,
) =>
	matchesSelectedFiltersByQueryKeys({
		result,
		selectedFilters,
		filters,
		...matchesSelectedFiltersConfig,
		rejectWhenNoFilterData: true, // Events require AND logic - reject if filter field is empty
	});

export const filterEventResults = (
	results: Array<WebAPIEventResult> | undefined,
	selectedFilters: SelectedFiltersMap,
	filters: EventFilters,
) => {
	return (results ?? []).filter((result) =>
		matchesSelectedFilters(result, selectedFilters, filters),
	);
};
